/*
 *  Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import _get from "lodash/get";
import _has from "lodash/has";
import { FieldType } from "@/src/types/formatServiceTypes/FieldType";
import { translate } from "./translations/translations";
import dayjs from "dayjs";

export const eur = (v: number | string | null | undefined) => {
  const floatValue = typeof v === "string" ? parseFloat(v) : v;

  const n =
    String(floatValue) === v
      ? floatValue
      : Number(
          String(v ?? 0)
            .replace(/\./g, "")
            .replace(",", ".")
        );
  return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR", useGrouping: true }).format(n ?? 0.0);
};

export const dayjsToGermanDate = (value: string) => (dayjs(value).isValid() ? dayjs(value).format("DD.MM.YYYY") : value);

export function convertValueDependingOnFieldType(caseData: Record<string, any>, fieldPath: string, fieldType: FieldType) {
  if (!fieldType) {
    return _get(caseData, fieldPath);
  }

  switch (fieldType) {
    case "float":
      return parseFloat(_get(caseData, fieldPath)).toString().replace(".", ",");
    case "date":
      return dayjsToGermanDate(_get(caseData, fieldPath));
    case "money":
      return eur(parseInt(_get(caseData, fieldPath)));
    case "dateMY":
      return dayjs(_get(caseData, fieldPath)).format("MMMM YYYY");
    case "yesNo":
      return _get(caseData, fieldPath) === true ? "Ja" : "Nein";
    case "time":
      return dayjs(_get(caseData, fieldPath)).format("HH:mm");
    case "multipleOptions":
      const selectedOptions = _get(caseData, fieldPath);

      return selectedOptions
        .map((selectedOption: string) => translate(`${caseData.name}.${fieldPath}.options.${selectedOption}.label`, caseData, _get(caseData, fieldPath)))
        .join(", ");
  }
}

export function fieldPathValueCanBeDisplayed(caseData: any, fieldPath: string): boolean {
  return _has(caseData, fieldPath) && (_get(caseData, fieldPath) !== null || fieldPath === "gender" || fieldPath.endsWith(".gender"));
}

export const formatNumber = (num: number) => {
  return new Intl.NumberFormat("de-DE").format(num);
};
